module.exports = __webpack_public_path__ + "static/new-email-5a1bd3a1d298110e8bc6cecf55f49492.jpg";